import { render, staticRenderFns } from "./ObjectRendering.vue?vue&type=template&id=36e61c18&scoped=true&"
import script from "./ObjectRendering.vue?vue&type=script&lang=js&"
export * from "./ObjectRendering.vue?vue&type=script&lang=js&"
import style0 from "./ObjectRendering.vue?vue&type=style&index=0&id=36e61c18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e61c18",
  null
  
)

export default component.exports